import { render } from "./SleepNaps.vue?vue&type=template&id=4eec52ec&scoped=true"
import script from "./SleepNaps.vue?vue&type=script&lang=js"
export * from "./SleepNaps.vue?vue&type=script&lang=js"

import "./SleepNaps.vue?vue&type=style&index=0&id=4eec52ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eec52ec"]])

export default __exports__